import React from 'react';
import { FiTrendingUp } from 'react-icons/fi';
import { useCurrentPerson } from '../../hooks/useCurrentPerson';
import { useDatabase } from '../../hooks/useDatabase';
import PersonMappingPrompt from '../../components/common/PersonMappingPrompt';
import PersonalWorkboard from '../../components/dashboards/PersonalWorkboard';
import { PersonalForecast } from '../../components/planning/PersonalForecast';

const YourWorkPage: React.FC = () => {
  const { personId, setPersonId, isMapped, loading } = useCurrentPerson();
  const { dependencyGraph } = useDatabase();

  if (loading) {
    return (
      <div className="flex items-center gap-3 justify-center p-12 text-cm-text-muted text-sm">
        <div className="w-5 h-5 border-2 border-cm-accent-orange border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  if (!isMapped) {
    return <PersonMappingPrompt onSelect={setPersonId} />;
  }

  return (
    <div className="max-w-6xl mx-auto space-y-6">
      <div>
        <h1 className="text-2xl font-mono font-semibold text-cm-text-primary">Your Work</h1>
        <p className="mt-1 text-sm text-cm-text-secondary">
          What you're working on, what's next, and your personal forecast.
        </p>
      </div>

      {/* ── Assigned Tasks + Work Queue ─────────────────────────── */}
      <PersonalWorkboard personId={personId!} dependencyGraph={dependencyGraph} />

      {/* ── Personal Forecast ──────────────────────────────────── */}
      <div className="rounded-xl border border-cm-border-subtle bg-cm-bg-surface p-6">
        <div className="flex items-center gap-2 mb-4">
          <FiTrendingUp className="w-5 h-5 text-cm-accent-purple" />
          <h3 className="font-mono font-medium text-cm-text-primary">Personal Forecast</h3>
          <span className="text-xs text-cm-text-muted ml-auto">probabilistic schedule</span>
        </div>
        <PersonalForecast personId={personId!} dependencyGraph={dependencyGraph} />
      </div>
    </div>
  );
};

export default YourWorkPage;
